import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import "@progress/kendo-theme-default/dist/all.css";
import "./Css/Site.css";
import "./Css/SDObasic-blue.css";
import "font-awesome/css/font-awesome.min.css";
import "ie11-custom-properties";

//@ts-ignore
if (window.MSInputMethodContext && document.documentMode) {
  // import('ie11-custom-properties');
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <div>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </div>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister(); // prevent PWA suggestion
// serviceWorker.register();
